module.exports = __webpack_public_path__ + "media/dance_start.63140880.mp3";